import React from 'react'
import TurnLeftSharpIcon from '@mui/icons-material/TurnLeftSharp';
import TurnSharpLeftIcon from '@mui/icons-material/TurnSharpLeft';
import TurnSlightLeftSharpIcon from '@mui/icons-material/TurnSlightLeftSharp';
// import UTurnLeftSharpIcon from '@mui/icons-material/UTurnLeftSharp';
import TurnRightSharpIcon from '@mui/icons-material/TurnRightSharp';
import TurnSlightRightSharpIcon from '@mui/icons-material/TurnSlightRightSharp';
import TurnSharpRightIcon from '@mui/icons-material/TurnSharpRight';
import UTurnRightSharpIcon from '@mui/icons-material/UTurnRightSharp';
import SouthWestSharpIcon from '@mui/icons-material/SouthWestSharp';
import SouthSharpIcon from '@mui/icons-material/SouthSharp';
import SouthEastSharpIcon from '@mui/icons-material/SouthEastSharp';
import NorthSharpIcon from '@mui/icons-material/NorthSharp';
import NorthEastSharpIcon from '@mui/icons-material/NorthEastSharp';
import NorthWestSharpIcon from '@mui/icons-material/NorthWestSharp';
import ForkLeftSharpIcon from '@mui/icons-material/ForkLeftSharp';
import ForkRightSharpIcon from '@mui/icons-material/ForkRightSharp';
import RoundaboutRightSharpIcon from '@mui/icons-material/RoundaboutRightSharp';
import RoundaboutLeftSharpIcon from '@mui/icons-material/RoundaboutLeftSharp';
import StraightSharpIcon from '@mui/icons-material/StraightSharp';
import WhereToVoteSharpIcon from '@mui/icons-material/WhereToVoteSharp';
import RampLeftSharpIcon from '@mui/icons-material/RampLeftSharp';
// import RampRightSharpIcon from '@mui/icons-material/RampRightSharp';
import { bgColors } from '../utils/bgColor';
export default function Directionicons(text) {

    const style = {
      color: bgColors.font_blue
    }
    if(text.search('Drive south') >-1){
      return <SouthSharpIcon 
        style = {style}
      />
    }
    else if(text.search('Drive southeast') >-1){
      return <SouthEastSharpIcon
      style = {style}
      />
    }
    else if(text.search('Drive southwest') >-1){
      return <SouthWestSharpIcon
      style = {style}
      />
    }

    else if(text.search('Drive north') >-1){
      return <NorthSharpIcon
      style = {style}
      />
    }
    else if(text.search('"Drive northheast') >-1){
      return <NorthEastSharpIcon
      style = {style}
      />
    }
    else if(text.search('Drive northwest') >-1){
      return <NorthWestSharpIcon
      style = {style}
      />
    }
    else if(text.search('Bear right')> -1)
    {return <TurnSlightRightSharpIcon
      style = {style}
    />}
    else if(text.search('Bear left')> -1)
    {return <TurnSlightLeftSharpIcon
      style = {style}
    
    />}
    else if(text.search('Turn right')> -1)
    {return <TurnRightSharpIcon
      style = {style}
    
    />}
    else if(text.search('Turn left')> -1)
    {return <TurnLeftSharpIcon
      style = {style}
    />}
    else if(text.search('sharp left')> -1)
    {return <TurnSharpLeftIcon
      style = {style}
    
    />}
    else if(text.search('sharp right')> -1)
    {return <TurnSharpRightIcon
      style = {style}
    />}
    else if(text.search('exit on the right')> -1)
    {return <ForkRightSharpIcon
      style = {style}
    />}
    else if(text.search('roundabout and take the 1st exit ')> -1)
    {return <RoundaboutLeftSharpIcon
      style = {style}
    />}
    else if(text.search('roundabout and take the 2nd exit')> -1)
    {return <StraightSharpIcon
      style = {style}
    />}
    else if(text.search('roundabout and take the 1st exit ')> -1)
    {return <RoundaboutLeftSharpIcon
      style = {style}
    />}
    else if(text.search('Keep right')> -1)
    {return <TurnSharpRightIcon
      style = {style}
    />}
    else if(text.search('Keep left')> -1)
    {return <TurnSharpLeftIcon
      style = {style}
    />}
    else if(text.search('uturn')> -1)
    {return <UTurnRightSharpIcon
      style = {style}
    />}
    else if(text.search('exit')> -1)
    {return <ForkLeftSharpIcon
      style = {style}
    />}
    else if(text.search('arrived')> -1)
    {return <WhereToVoteSharpIcon
      style = {style}
    />}
    else if(text.search('ramp')> -1)
    {return <RampLeftSharpIcon
      style = {style}
    />}
    else if(text.search('destination')> -1)
    {return <WhereToVoteSharpIcon
      style = {style}
    />}
    
    else if(text.search('roundabout and take the 3rd exit')> -1)
    {return <RoundaboutRightSharpIcon
      style = {style}
    />}

    else {
      return <WhereToVoteSharpIcon
      style = {style}
      />
    }

}